import React, { useEffect, useState } from "react";
import { Card, Spinner, Form } from "react-bootstrap";
import { collection, getDocs, updateDoc, doc } from "firebase/firestore";
import { db } from "../firebase";
import Swal from "sweetalert2";

const AppSetupAction = () => {
  const [settings, setSettings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const collectionRef = collection(db, "appSetupAction");
        const querySnapshot = await getDocs(collectionRef);

        const fetchedSettings = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setSettings(fetchedSettings);
      } catch (error) {
        console.error("Error fetching settings:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  const handleToggle = async (id, newValue) => {
    const docRef = doc(db, "appSetupAction", id);
    try {
      await updateDoc(docRef, {
        allowDisallow: newValue,
      });

      setSettings((prev) =>
        prev.map((s) =>
          s.id === id ? { ...s, allowDisallow: newValue } : s
        )
      );

      Swal.fire("Updated", "Setting updated", "success");
    } catch (error) {
      console.error("Error updating:", error);
      Swal.fire("Error", "Failed to update", "error");
    }
  };

  if (loading) return <Spinner animation="border" />;

  return (
    <>
      {settings.map((setting) => (
        <Card key={setting.id} className="shadow-sm border-0 mb-3">
          <Card.Body>
            <h5 className="fw-bold mb-3">
              {setting.description || "Setting"}
            </h5>
            <Form>
              <Form.Check
                type="switch"
                id={`switch-${setting.id}`}
                label={setting.allowDisallow ? "Enabled" : "Disabled"}
                checked={setting.allowDisallow}
                onChange={(e) =>
                  handleToggle(setting.id, e.target.checked)
                }
              />
            </Form>
          </Card.Body>
        </Card>
      ))}
    </>
  );
};

export default AppSetupAction;
